export default __webpack_public_path__ + "static/media/slide-1.aa6c5a4a.webp";